import { StateProvider } from '@uirouter/angularjs';
import { publicStateName } from '../public/public-routing';

export function authRoutesConfig( $stateProvider: StateProvider ) {
  const authStateName = `${publicStateName}.auth`;
  $stateProvider
    .state(`${authStateName}`, {
      // abstract: true,
      component: 'auth'
    })
    .state(`${authStateName}.login`, {
      url: '/login',
      component: 'login',
      resolve: {
        $title: () => 'Login'
      }
    })
    .state(`${authStateName}.password-recovery`, {
      url: '/password-recovery',
      component: 'passwordRecovery',
      resolve: {
        $title: () => 'Password Recovery'
      }
    })
    .state(`${authStateName}.activate`, {
      url: '/activate/:code',
      component: 'accountActivation',
      resolve: {
        $title: () => 'Account Activation'
      }
    })
    .state(`${authStateName}.registration`, {
      url: '/registration?id',
      component: 'registration',
      resolve: [
        {
          provide: '$title',
          useFactory: () => 'Registration'
        }
      ]
    });
}

authRoutesConfig.$inject = [
  '$stateProvider'
];



// WEBPACK FOOTER //
// ./app/states/auth/auth-routing.ts